module.exports = __webpack_public_path__ + "img/icons8-user-groups-64.c754c7fd.svg";